// plugins/03.axios.ts
import axios from 'axios'
import { useAuthStore } from '~/store/auth'

const templateError = {
	success: false,
	status: '',
	message: 'Error desconocido',
}

export default defineNuxtPlugin((nuxtApp) => {
	const config = useRuntimeConfig()

	const $axios = axios.create({
		baseURL: config.public.apiBase || '',
	})

	// ✅ REQUEST INTERCEPTOR (mete Bearer siempre)
	$axios.interceptors.request.use(
		(req) => {
			const auth = useAuthStore()

			// token store o cookie
			const cookieToken = useCookie<string | null>(config.public.auth.name_cookie).value
			const token = auth.token || cookieToken

			if (token) {
				req.headers = req.headers || {}
				req.headers.Authorization = `Bearer ${token}`
			}
			return req
		},
		(error) => Promise.reject(error),
	)

	// RESPONSE (tu código igual)
	$axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (!error.response) return Promise.reject(templateError)
			const responseData = error.response.data

			const errorResponse = {
				data: { ...responseData, statusCode: error.response.status },
			}

			return Promise.reject(errorResponse)
		},
	)

	nuxtApp.provide('axios', $axios)
})
